export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/api-keys": [19],
		"/data-qa": [16],
		"/data-qa/datasets": [17],
		"/data-qa/runs": [18],
		"/huggingface-tokens": [21],
		"/invitations": [6],
		"/label-studio": [4],
		"/llm": [11],
		"/llm/evals": [13],
		"/llm/evals/launch-eval": [14],
		"/llm/llms": [12],
		"/llm/runs": [15],
		"/login": [22],
		"/organizations": [5],
		"/signup": [3],
		"/storage-configs": [20],
		"/unlearn-data": [7],
		"/unlearn-data/models": [8],
		"/unlearn-data/runs": [9],
		"/user-associations": [10]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';